import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';

const Hero = () => {
  // Hero image from Liv photoshoot - bold and eye-catching
  const heroImage = 'https://res.cloudinary.com/diaz39dwx/image/upload/v1762796449/ky-portfolio/eoroewg4almp5ndzjym6.jpg';

  return (
    <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
      {/* Full-bleed background image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundPosition: 'center 40%',
        }}
      >
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Hero content */}
      <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 pt-20">
        <div className="max-w-5xl mx-auto text-center lg:text-left lg:max-w-3xl">
          {/* Main headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-display-lg font-heading font-bold text-white mb-6 leading-tight tracking-tight">
            Capturing Your
            <span className="block text-accent-secondary mt-2">Confidence & Authenticity</span>
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl lg:text-2xl text-white/90 font-body mb-10 max-w-2xl mx-auto lg:mx-0 leading-relaxed">
            Capturing people as they truly are—beautiful, confident, and full of life.
            Creating images that help you see the version of yourself you want to share.
          </p>

          {/* CTA buttons */}
          <div className="flex flex-col sm:flex-row gap-5 justify-center lg:justify-start">
            <Link to="/portfolio">
              <Button
                variant="primary"
                size="lg"
                className="bg-accent text-white hover:bg-accent-secondary transition-all duration-400 shadow-lg hover:shadow-hover min-w-[180px]"
              >
                View Portfolio
              </Button>
            </Link>
            <Link to="/contact">
              <Button
                variant="outline"
                size="lg"
                className="border-2 border-white text-white hover:bg-white hover:text-secondary transition-all duration-400 backdrop-blur-sm min-w-[180px]"
              >
                Get in Touch
              </Button>
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 hidden md:block">
        <div className="flex flex-col items-center text-white/80 animate-bounce">
          <span className="text-sm font-body mb-2 tracking-wider">Scroll</span>
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 14l-7 7m0 0l-7-7m7 7V3"
            />
          </svg>
        </div>
      </div>
    </section>
  );
};

export default Hero;
